import {component, EntityData, field, identifier} from "@fedeltapointofsale/data-client";

/**
 * Logged in User Profile summary information
 */

export class UserProfileAccessRoleData extends EntityData<UserProfileAccessRoleData> {
    @identifier accessRoleId: number;
    @field name: string;
}

export class UserProfileContactData extends EntityData<UserProfileContactData> {
    @identifier id: string;
    @field workPhone: string;
    @field mobilePhone: string;
    @field email: string;
}

export class UserProfileEmployeeData extends EntityData<UserProfileEmployeeData> {
    @identifier employeeId: number;
    @field status: string;
    @component contact: UserProfileContactData;
}

export class UserProfileSummaryData extends EntityData<UserProfileSummaryData> {
    @identifier userId: number;
    @field name: string;
    @field firstName: string;
    @field lastName: string;
    @component accessRole: UserProfileAccessRoleData;
    @component employee: UserProfileEmployeeData;
}
